module.exports = __webpack_public_path__ + "img/bottom.a80e0643.png";